import { Widget } from '@kanda-libs/ks-component-ts';

import SecondaryEmploymentFields from './Fields';
import useSecondaryEmployment from './useSecondaryEmployment';

import AddEmploymentButton from '../components/AddEmploymentButton';

const SecondaryEmployment: React.FunctionComponent = function () {
  const { showButton } = useSecondaryEmployment();
  if (!showButton) return null;
  return (
    <Widget.CreditAdditionalEmploymentDetailsArrayWrapper initialData={[]}>
      {({ arrayName, fields, arrayProps: { append, remove } }) => (
        <>
          {fields.map((field, index) => (
            <SecondaryEmploymentFields
              index={index}
              arrayName={arrayName}
              remove={remove}
              key={field.id}
            />
          ))}
          <div className="border-b border-neutral-300 mb-4" />
          <AddEmploymentButton append={append} />
        </>
      )}
    </Widget.CreditAdditionalEmploymentDetailsArrayWrapper>
  );
};

export default SecondaryEmployment;
